import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableHaberFormGroup = ({ iError, iTouched, iValue, values, setValues }) => {
  const onChange = React.useCallback(
    salida => {
      values.cuentaContableHaber = salida.value
      values.cuentaContableHaberInfo = salida.label
      values.cuentaContableHaberTipoDocumento = salida.tipoDocumento
      values.flagCentroCostoCuentaContableHaber = salida.flagCentroCosto
      values.esCuentaActivoFijoCuentaContableHaber = salida.esActivoFijo
      values.tipoSocioCuentaContableHaber = salida.tipoSocio

      if (!salida.value.startsWith('6') && !salida.value.startsWith('9')) {
        values.tipoAfectacionCuentaContableHaber = ''
      }

      setValues(values)

      setTimeout(() => {
        KeyEventUtil.leaveOnKeyEvent(`date-entregaARenidr-fechaEmision`)
      }, 200)
    },
    [values, setValues]
  )

  const clickClear = React.useCallback(() => {
    values.cuentaContableHaber = ''
    values.cuentaContableHaberInfo = ''
    values.cuentaContableHaberTipoDocumento = ''
    values.flagCentroCostoCuentaContableHaber = false
    values.esCuentaActivoFijoCuentaContableHaber = false
    values.tipoSocioCuentaContableHaber = ''
    values.tipoAfectacionCuentaContableHaber = ''

    setValues(values)

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent(`select-entregaARenidr-cuentaContableHaber`)
    }, 200)
  }, [values, setValues])

  return (
    <Form.Group>
      <Form.Label text='CUENTA HABER' htmlFor='select-entregaARenidr-cuentaContableHaber' md={4} alignRightAt='md' />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='clearinput-entregaARenidr-cuentaContableHaber' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-entregaARenidr-cuentaContableHaber' onlyAnalitica onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableHaberFormGroup)
